import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

// const OAuthCallbackPage = lazy(() =>
//   import('../features/oauth/pages/index')
// );

const OAuthRoutes = () => {
  return (
    <Suspense fallback={<div>Loading oauth...</div>}>
      <Routes>
        {/* <Route path="callback" element={<OAuthCallbackPage />} /> */}
      </Routes>
    </Suspense>
  );
};

export default OAuthRoutes;